export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5476.10ab4fad.jpg";